import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, FormGroup, Modal, Button, FormControl, ControlLabel, Checkbox, } from "react-bootstrap";
import Select from "react-select";
import LoaderInline from "../helpers/LoaderInline";
import InlineError from "../messages/InlineError";

class NewTaskModal extends React.Component { 

	submit = (e) => {
		e.preventDefault();
		this.props.onTaskCreateSubmit();
	}

	render () {
		return(	
			<Modal bsSize="lg" className="log-hours-modal" show={this.props.showNewTaskModal} onHide={this.props.handleCloseModal}>
				<form onSubmit={this.submit}>	
					<Modal.Header>
						<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={this.props.handleCloseModal}>&times;</button>
						<Modal.Title>New task</Modal.Title>
					</Modal.Header>
		
					<Modal.Body>						
						<FormGroup validationState={this.props.newTaskErrors.name && "error"}>
							<ControlLabel>Name</ControlLabel>
							<FormControl type="text" name="name" placeholder="Enter task name" value={this.props.newTaskFormData.name || ""} onChange={(e)=>this.props.onChange(e,"newTaskFormData")} />
							{this.props.newTaskErrors.name && <InlineError text={this.props.newTaskErrors.name} />}								                                
						</FormGroup>
						<Row>
							<Col md={6}>
								<FormGroup validationState={this.props.newTaskErrors.project_id && "error"}>
									<ControlLabel>Project</ControlLabel>	
									<Select
										onChange={()=>null}
										name="project_id"
										placeholder="Choose project "
										value={this.props.selectedProject}
										options={[]}
										clearable={false}
										multi={false}
										disabled
									/>
									{this.props.newTaskErrors.project_id && <InlineError text={this.props.newTaskErrors.project_id} />}	
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup validationState={this.props.newTaskErrors.area_id && "error"}>
									<ControlLabel>Area</ControlLabel>	
									<Select
										onChange={(option) => { this.props.onSelectChange(option, "area_id", "selectedArea" ,"newTaskFormData"); }}
										name="area_id"
										placeholder="Choose area"
										value={this.props.selectedArea}
										options={this.props.areas}
										isLoading={false}
										disabled={this.props.disableArea}
										clearable={false}
										multi={false}
									/>
									{this.props.newTaskErrors.area_id && <InlineError text={this.props.newTaskErrors.area_id} />}	
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col lg={4} md={4} sm={4} xs={12}>
								<FormGroup className="edit-placeholder" validationState={this.props.newTaskErrors.assigned_to && "error"}>
									<ControlLabel>Assign to</ControlLabel>	
									<Select.Async
										onChange={(option) => { this.props.onEmployeeSelectChange(option, "newTaskSelectedEmployee", "newTaskFormData"); }}
										name="assigned_to"
										placeholder="Choose employee"
										value={this.props.newTaskSelectedEmployee}
										labelKey="full_name"
										valueKey="id"
										loadOptions={(e,c) => this.props.handleAsyncSearch(e,"user","roles=2,4",c)}
										clearable={false}
										multi={false}
									/>
									{this.props.newTaskErrors.assigned_to && <InlineError text={this.props.newTaskErrors.assigned_to} />}
								</FormGroup>
							</Col>
							<Col lg={4} md={4} sm={4} xs={12}>
								<FormGroup validationState={this.props.newTaskErrors.status_id && "error"}>
									<ControlLabel>Status</ControlLabel>	
									<Select
										onChange={(option) => { this.props.onSelectChange(option, "status_id", "selectedStatus", "newTaskFormData"); }}
										name="status_id"
										placeholder="Choose task status"
										value={this.props.newTaskFormData.status_id || ""}
										options={this.props.statuses}
										isLoading={this.props.isLoadingStatuses}
										clearable={false}
										multi={false}
									/>
									{this.props.newTaskErrors.status_id && <InlineError text={this.props.newTaskErrors.status_id} />}
								</FormGroup>
							</Col>
							<Col lg={4} md={4} sm={4} xs={12}>
								<FormGroup validationState={this.props.newTaskErrors.estimated && "error"}>
									<ControlLabel>Estimation (Hours)</ControlLabel>                                  
									<FormControl  min="0" type="text" name="estimated" placeholder="Enter task estimation"  value={this.props.newTaskFormData.estimated || ""} onChange={(e)=>this.props.onChange(e,"newTaskFormData")}/>						
									{this.props.newTaskErrors.estimated && <InlineError text={this.props.newTaskErrors.estimated} />}								                                							
								</FormGroup>
							</Col>
						</Row>
						
						<FormGroup validationState={this.props.newTaskErrors.forced_to_log && "error"}>
							<Checkbox name="forced_to_log" inline checked={this.props.newTaskFormData.forced_to_log} onChange={(e)=>this.props.onCheckboxChange(e,"newTaskFormData")}>
								Force user to log at this task 
							</Checkbox> 
							{this.props.newTaskErrors.forced_to_log && <InlineError text={this.props.newTaskErrors.forced_to_log} />}	
						</FormGroup>

						<FormGroup>
							<Checkbox name="parent" inline disabled={this.props.disableParent} checked={this.props.newTaskFormData.parent} onChange={(e)=>this.props.onCheckboxChange(e,"newTaskFormData")}>
								Choose task parent
							</Checkbox> 
						</FormGroup>
						{	this.props.newTaskFormData.parent && 							
							<FormGroup validationState={this.props.newTaskErrors.parent_id && "error"}>
								<ControlLabel>Parent Task</ControlLabel>	
								<Select.Async
									onChange={(option) => { this.props.onSelectChange(option, "parent_id", "newTaskParent", "newTaskFormData"); }}
									name="parent_id"
									placeholder="Choose parent task"
									value={this.props.newTaskParent}
									labelKey="name"
									valueKey="id"
									loadOptions={(e,c) => this.props.handleAsyncSearch(e,"task",null,c)}
									clearable={false}
									multi={false}
									disabled={this.props.disableParent} 
								/>
								{this.props.newTaskErrors.parent_id && <InlineError text={this.props.newTaskErrors.parent_id} />}	
							</FormGroup>
						}
						<FormGroup validationState={this.props.newTaskErrors.description && "error"}>
							<ControlLabel>Description</ControlLabel>                                  
							<FormControl componentClass="textarea" name="description" value={this.props.newTaskFormData.description || ""} onChange={(e)=>this.props.onChange(e,"newTaskFormData")}/>																				                                							
							{this.props.newTaskErrors.description && <InlineError text={this.props.newTaskErrors.description} />}	
						</FormGroup>
					</Modal.Body>
		
					<Modal.Footer>
						<Button bsStyle="primary" className="btn-min" type={"submit"}>
							{this.props.saveTaskLoading ? <LoaderInline width="20" height="20" color="#fff" /> : "Save"}
						</Button>
						<Button bsStyle="default" className="btn-min" onClick={this.props.handleCloseModal}>Close</Button>
					</Modal.Footer>
				</form>
			</Modal>
		);
	}
}

NewTaskModal.defaultProps = {
	saveTaskLoading: false,
	isLoadingStatuses: false,
	disableArea: false,
	disableParent: false,
	selectedProject: null,
	selectedArea: null,
	newTaskParent: null,
	newTaskSelectedEmployee: null,
	areas: [],
	newTaskErrors: {},
};

NewTaskModal.propTypes = {
	isLoadingStatuses: PropTypes.bool,
	disableArea: PropTypes.bool,
	disableParent: PropTypes.bool,
	saveTaskLoading: PropTypes.bool,
	showNewTaskModal: PropTypes.bool.isRequired,
	newTaskFormData: PropTypes.shape({
		name: PropTypes.string,
		parent: PropTypes.bool,
		description: PropTypes.string,
		status_id: PropTypes.number,
		estimated: PropTypes.string,
		forced_to_log: PropTypes.bool
	}).isRequired,
	newTaskErrors: PropTypes.shape({
		name: PropTypes.string, 
		parent_id: PropTypes.string,
		area_id: PropTypes.string,
		project_id: PropTypes.string,
		assigned_to: PropTypes.string,
		estimated: PropTypes.string, 
		description: PropTypes.string,
		forced_to_log: PropTypes.string,
		status_id: PropTypes.string,
	}),
	statuses: PropTypes.arrayOf(
		PropTypes.object
	).isRequired,
	selectedArea: PropTypes.shape({
		value: PropTypes.number,
		label: PropTypes.string
	}),
	selectedProject: PropTypes.shape({
		value: PropTypes.number,
		label: PropTypes.string
	}),
	newTaskParent: PropTypes.shape({
		value: PropTypes.number,
		label: PropTypes.string
	}),
	newTaskSelectedEmployee: PropTypes.shape({
		id: PropTypes.string,
		full_name: PropTypes.string
	}),
	areas: PropTypes.arrayOf(
		PropTypes.object
	),
	onTaskCreateSubmit: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	onCheckboxChange: PropTypes.func.isRequired,
	onEmployeeSelectChange: PropTypes.func.isRequired,
	onSelectChange: PropTypes.func.isRequired,
	handleCloseModal: PropTypes.func.isRequired,
	handleAsyncSearch: PropTypes.func.isRequired,
};

export default NewTaskModal;



// WEBPACK FOOTER //
// ./src/components/modals/NewTaskModal.js